//Global Imports
import React from "react";
//End Global Imports

const Header = () => {
  return (
    <div className="flex flex-col items-center justify-center w-full mt-[129px]">
      {/* <img src={"/images/svg/sbm-white-logo.svg"} alt="sbm-logo" height="61px" width="244px" /> */}
      <div className="flex flex-col items-center space-y-3 pb-[73px] sm:hidden">
        <div className="text-[22px] font-semibold pt-11 text-primary font-ssp">
          Cross-border payments made
        </div>
        <div className="text-base font-normal font-ssp text-black-100">Smarter, Faster, Better</div>
      </div>
    </div>
  );
};

export default Header;
